import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SortDropdown = ({ currentSort, onSortChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const sortOptions = [
    { value: 'featured', label: 'Featured', icon: 'Star' },
    { value: 'name-asc', label: 'Name: A to Z', icon: 'ArrowUp' },
    { value: 'name-desc', label: 'Name: Z to A', icon: 'ArrowDown' },
    { value: 'price-asc', label: 'Price: Low to High', icon: 'TrendingUp' },
    { value: 'price-desc', label: 'Price: High to Low', icon: 'TrendingDown' },
    { value: 'rating', label: 'Highest Rated', icon: 'Award' },
    { value: 'newest', label: 'Newest First', icon: 'Clock' }
  ];

  const currentSortOption = sortOptions?.find(option => option?.value === currentSort) || sortOptions?.[0];

  const handleSortSelect = (sortValue) => {
    onSortChange(sortValue);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 min-w-[180px] justify-between"
      >
        <div className="flex items-center space-x-2">
          <Icon name={currentSortOption?.icon} size={16} />
          <span className="font-inter">{currentSortOption?.label}</span>
        </div>
        <Icon 
          name={isOpen ? "ChevronUp" : "ChevronDown"} 
          size={16} 
          className="brand-transition" 
        />
      </Button>
      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute top-full right-0 mt-2 w-56 bg-card border border-border rounded-lg liquid-shadow py-2 z-20">
            {sortOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => handleSortSelect(option?.value)}
                className={`w-full flex items-center space-x-3 px-4 py-2 text-left brand-transition ${
                  currentSort === option?.value
                    ? 'bg-primary/10 text-primary border-r-2 border-primary' :'text-text-primary hover:bg-muted'
                }`}
              >
                <Icon name={option?.icon} size={16} />
                <span className="font-inter">{option?.label}</span>
                {currentSort === option?.value && (
                  <Icon name="Check" size={16} className="ml-auto" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SortDropdown;